<template>
<div class="max-w-2xl w-full">
  <h4>{{ $t('message.salaryProject.requestHeader') }}</h4>
  <div>
    <label class="mt-4 flex">
      <div class="w-1/4 text-right leading-form pr-4">{{ $t('message.salaryProject.formLastname') }}</div>
      <vs-input class="inputx w-128" v-model="lastName"/>
    </label>
    <label class="flex mt-4">
      <div class="w-1/4 text-right leading-form pr-4">{{ $t('message.salaryProject.formName') }}</div>
      <vs-input class="inputx w-128" v-model="name"/>
    </label>
    <label class="flex mt-4">
      <div class="w-1/4 text-right leading-form pr-4">{{ $t('message.salaryProject.formSecondName') }}</div>
      <vs-input class="inputx w-128" v-model="secondName"/>
    </label>
    <div class="flex mt-4">
      <div class="w-1/4 text-right leading-form pr-4">{{ $t('message.salaryProject.formBirthDate') }}</div>
      <datepicker
        v-model="birthDate"
        :language="lang[$i18n.locale]"
        :full-month-name="true"
        :monday-first="true"
        :placeholder="$t('message.salaryProject.formBirthDate')"
        :format="'dd MMMM yyyy'"
        class="w-64 inline-block placeholder-white"
      ></datepicker>
    </div>
    <vs-divider />
    <p class="w-1/4 mx-auto pr-4 pb-4">{{ $t('message.salaryProject.formPassport') }}</p>
    <div class="flex">
      <div class="w-1/4 leading-normal pt-5" />
      <div class="w-3/4 flex flex-wrap">
        <div class="w-full">
          <vs-select v-model="genderType" width="300px" class="w-1/2 pt-2" :placeholder="$t('message.salaryProject.genderPlaceholder')">
            <vs-select-item v-for="(val, key) in genderTypes"
                            :key="key" :text="$t(`message.salaryProject.${val}`)" :value="key" />
          </vs-select>
        </div>
        <div class="w-full">
          <vs-input :placeholder="$t('message.salaryProject.phonePlaceholder')" v-model="phone" class="w-1/2 py-2" />
        </div>
      </div>
    </div>
    <div class="flex">
      <div class="w-1/4 leading-normal pt-5">
        {{ $t('message.salaryProject.formPassportName') }}
      </div>
      <div class="w-3/4 flex flex-wrap">
        <vs-select v-model="passportType" class="w-1/2" :placeholder="$t('message.salaryProject.passportPlaceholder')">
          <vs-select-item v-for="(val, key) in passportTypes"
                          :key="key" :text="$t(`message.salaryProject.${val}`)" :value="key" />
        </vs-select>
        <vs-input class="inputx w-full pr-2 mt-2" :placeholder="$t('message.salaryProject.formPassportId')"
                  v-model="passportId"/>
        <datepicker
          v-model="passportData"
          :placeholder="$t('message.salaryProject.formPassportData')"
          :language="lang[$i18n.locale]"
          :full-month-name="true"
          :monday-first="true"
          :format="'dd MMMM yyyy'"
          class="w-1/2 inline-block mt-2 pr-2"
        >
          <span slot="beforeCalendarHeader" class="animated-placeholder">
            Choose a Date
          </span>
        </datepicker>
        <vs-input class="inputx w-1/2 pr-2 mt-2" :placeholder="$t('message.salaryProject.formPassportWho')"
                  v-model="passportWho"/>
        <vs-select v-model="residentSign" class="w-1/2 pt-2" :placeholder="$t('message.salaryProject.residentPlaceholder')">
          <vs-select-item v-for="(val, key) in residentTypes"
                          :key="key" :text="$t(`message.salaryProject.${val}`)" :value="key" />
        </vs-select>
        <label class="w-2/3 leading-form text-left">
          <vs-upload
            :limit="1"
            :multiple="false"
            fileName="files"
            :text="$t('message.salaryProject.formPassportUploadFront')"
            action="/v1/salary/upload/"
            class="w-1/2 mt-8"
            :headers="{
              'Authorization': `Bearer ${accessToken}`
            }"
            @on-success="(event) => updateFile('front', event)"
            @on-error="() => updateErrorFile('front')"
            @on-delete="() => deleteFile('front')"
            :show-upload-button="false"
            :automatic="true"
          />
          <div v-if="loadError.front" class="text-danger">
            {{ $t('message.salaryProject.formUploadNotAdded') }}
          </div>
        </label>
        <vs-input class="inputx w-full pr-2 mt-2" :placeholder="$t('message.salaryProject.formPassportAddress')"
                  v-model="passportAddress"/>
        <vs-input class="inputx w-full pr-2 mt-2" :placeholder="$t('message.salaryProject.formPassportTaxId')"
                  v-model="passportTaxId"/>
        <label class="w-2/3 leading-form text-left">
          <vs-upload
            :limit="1"
            :multiple="false"
            fileName="files"
            :text="$t('message.salaryProject.formPassportUploadBack')"
            action="/v1/salary/upload/"
            class="w-1/2 mt-8"
            :headers="{
              'Authorization': `Bearer ${accessToken}`
            }"
            @on-success="(event) => updateFile('back', event)"
            @on-delete="() => deleteFile('back')"
            @on-error="() => updateErrorFile('back')"
            :show-upload-button="false"
            :automatic="true"
          />
          <div v-if="loadError.back" class="text-danger">
            {{ $t('message.salaryProject.formUploadNotAdded') }}
          </div>
        </label>
      </div>
    </div>
  </div>
  <div class="w-4/5 text-center mt-8 mx-auto">
    <vs-checkbox v-model="agree">{{ $t('message.salaryProject.formConfirm') }}</vs-checkbox>
  </div>
  <div class="w-2/3 mt-24  mx-auto">
    <vs-button @click="closeForm" line-origin="center"
               color="primary" type="flat" class="my-2 mr-2">
      {{ $t('message.salaryProject.formBack') }}
    </vs-button>
    <vs-button @click="confirmForm" line-origin="center" :disabled="!agree"
               color="primary" type="gradient" class="my-2 mr-2 float-right">
      {{ $t('message.salaryProject.formCreate') }}
    </vs-button>
  </div>
</div>
</template>

<script>
import Datepicker from 'vuejs-datepicker'
import {mapActions, mapGetters} from 'vuex'
import {en, ru} from 'vuejs-datepicker/dist/locale'

export default {
  name: 'requestForm',
  data: () => ({
    lastName: '',
    name: '',
    secondName: '',
    birthDate: null,
    passportId: '',
    passportType: null,
    passportData: '',
    passportWho: '',
    passportAddress: '',
    passportTaxId: '',
    genderType: null,
    phone: null,
    residentSign: null,
    lang: { ru, en },
    agree: false,
    file: {
      front: false,
      back: false
    },
    loadError: {
      front: false,
      back: false
    }
  }),
  methods: {
    ...mapActions('salary', ['sendFiles', 'addOnboardingRequest']),
    clearForm () {
      this.lastName = ''
      this.name = ''
      this.secondName = ''
      this.birthDate = null
      this.passportId = ''
      this.passportData = ''
      this.passportWho = ''
      this.passportAddress = ''
      this.passportTaxId = ''
      this.agree = false
      this.file.front = false
      this.file.back = false
    },
    confirmForm () {
      const date = new Date(this.birthDate)
      const info = {
        first_name: this.name,
        last_name: this.lastName,
        patronymic: this.secondName,
        doc_series: '',
        doc_numb: this.passportId,
        postal_address: this.passportAddress,
        approve_process: 0,
        path_doc_file: this.file.front,
        path_address_file: this.file.back,
        birth_day: date.toISOString().slice(0, 10),
        document_type: this.passportType,
        gender: this.genderType,
        phone_number: this.phone,
        residentSign: this.residentSign,
        tin: this.passportTaxId
      }
      this.$emit('confirm-form', info)
    },
    closeForm () {
      this.clearForm()
      this.$emit('close-form')
    },
    async updateFile (type, event) {
      this.file[type] = JSON.parse(event.target.response).files[0].file_name
      this.loadError[type] = false
    },
    async updateErrorFile (type) {
      this.loadError[type] = true
    },
    async deleteFile (type) {
      this.file[type] = false
      this.loadError[type] = false
    }
  },
  computed: {
    ...mapGetters('user', ['accessToken']),
    passportTypes: () => ({
      0: 'nationalPassport',
      1: 'foreignPassport'
    }),
    genderTypes: () => ({
      0: 'genderMale',
      1: 'genderFemale'
    }),
    residentTypes: () => ({
      0: 'yes',
      1: 'no'
    })
  },
  components: {
    Datepicker
  }
}
</script>

<style scoped lang="scss">
  .request {
    span {
      height: 50px;
      line-height: 55px;
    }
  }
</style>
